import styled from 'styled-components'
import { palette } from '../../../theme/palette'

const TypingContainer = styled.div`
  position: relative;
  margin-left: 22px;
`

const Loading = styled.div`
  position: relative;
  height: 26px;
  width: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${palette.white};
  border-radius: 14px 14px 14px 0;
  filter: drop-shadow(0px 1px 0px rgba(0, 0, 0, 0.04));
`

const Dot = styled.div`
  height: 6px;
  width: 6px;
  border-radius: 50%;
  background: ${palette.mediumGray};
  display: block;
  float: left;
  margin: 0 0 0 4px;
  -webkit-animation-direction: normal;
`

const DotFirst = styled(Dot)`
  margin: 0;
  -webkit-animation: cycleOne 1s ease-in-out infinite;
`

const DotSecond = styled(Dot)`
  -webkit-animation: cycleTwo 1s ease-in-out infinite;
`

const DotThird = styled(Dot)`
  -webkit-animation: cycleThree 1s ease-in-out infinite;
`

export { TypingContainer, Loading, DotFirst, DotSecond, DotThird }
